import React, { useState } from "react";
import { Form, Input, Button, Typography, Row, Col, Result, Alert } from "antd";
import { LockOutlined, CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import "../Login.css";

const { Title, Text } = Typography;

const Resetpassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleReset = async () => {
    if (!newPassword) return toast.error("Please enter a new password");
    if (newPassword.length < 8) return toast.error("Password must be at least 8 characters");
    if (newPassword !== confirmPassword) return toast.error("Passwords do not match");

    setLoading(true);
    try {
      await axios.put(`${base_url}user/reset-password/${token}`, { password: newPassword });
      setDone(true);
      setTimeout(() => navigate("/"), 3000);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Link expired or invalid. Please request a new one.");
    } finally {
      setLoading(false);
    }
  };

  const backgroundImageUrl = `${process.env.PUBLIC_URL}/admin-login.png`;

  // No token in URL
  if (!token) {
    return (
      <Row style={{ minHeight: "100vh" }}>
        <Col xs={24} className="right-block">
          <div className="login-card" style={{ maxWidth: 420 }}>
            <div className="login-card-accent" />
            <Result
              status="error"
              title="Invalid Reset Link"
              subTitle="This password reset link is invalid or has expired."
              extra={<Button type="primary" onClick={() => navigate("/forgot-password")}>Request New Link</Button>}
            />
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row style={{ minHeight: "100vh" }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Col
        xs={0} sm={0} md={12}
        style={{
          background: `url(${backgroundImageUrl}) no-repeat center center`,
          backgroundSize: "cover",
        }}
      />
      <Col xs={24} sm={24} md={12} className="right-block">
        <div className="login-card">
          <div className="login-card-accent" />

          <div className="text-center" style={{ marginBottom: 12 }}>
            <img
              src={`${process.env.PUBLIC_URL}/LNG_SKILLS_LOGO.png`}
              alt="LNJ Skills"
              style={{ width: 64, height: 56, objectFit: "contain" }}
            />
          </div>

          {!done ? (
            <>
              <Title level={3} className="text-center" style={{ marginBottom: 4 }}>
                Set New Password
              </Title>
              <Text className="text-center login-subtitle" type="secondary">
                Choose a strong password for your account
              </Text>

              <Alert
                type="info"
                showIcon
                message="This link is valid for 30 minutes only."
                style={{ marginBottom: 20, borderRadius: 8 }}
              />

              <Form layout="vertical" onFinish={handleReset}>
                <Form.Item label="New Password">
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "#4f46e5" }} />}
                    placeholder="Enter new password (min 8 chars)"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Form.Item>

                <Form.Item label="Confirm Password">
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "#4f46e5" }} />}
                    placeholder="Confirm your new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Form.Item>

                <Button
                  type="primary"
                  block
                  loading={loading}
                  onClick={handleReset}
                  icon={<CheckCircleOutlined />}
                >
                  Reset Password
                </Button>
              </Form>
            </>
          ) : (
            <Result
              status="success"
              title="Password Reset Successful!"
              subTitle="Your password has been updated. Redirecting to login..."
              extra={
                <Button type="primary" onClick={() => navigate("/")}>
                  Go to Login
                </Button>
              }
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Resetpassword;
